import axios from "axios";
export function sendRegister(data) {
  return new Promise((resolve, reject) => {
    axios.post("auth/register", data)
      .then(res => resolve(res.data))
      .catch(err => reject(err));
  })
}